import { useMediaQuery, useTheme } from '@mui/material';

/**
 * True at the `md` breakpoint and up. `noSsr` evaluates synchronously on mount
 * (these are client-only Vite SPAs) so consumers don't flash the wrong layout.
 *
 * Lives in `libs/ui` because it is the only place allowed to import MUI; app
 * code consumes the hook instead of reaching for `useMediaQuery` directly.
 */
export function useIsDesktop(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
}
